import React, { useState, useMemo, useRef } from "react";
import {
    MapContainer,
    TileLayer,
    Marker,
    Popup,
    useMapEvents,
} from "react-leaflet";
import L from "leaflet"
import "leaflet/dist/leaflet.css";

function MapEvents({ setPosition }) {
    const map = useMapEvents({
        click(e) {
            setPosition(e.latlng)
            map.flyTo(e.latlng, map.getZoom())
        },
        dragged(e) {
            console.log(e)
        }
    })

}

function ThingMarker({ thing }) {
    const icon = new L.Icon({
        iconUrl: `/static/img/community/${thing.type}.svg`,
        iconSize: [30, 30],
    })
    const markerRef = useRef(null)

    return thing.location === null ? null : (
        <Marker ref={markerRef} position={[thing.location[1], thing.location[0]]} icon={icon}>
            <Popup>
                <div className="community-map-popup">
                    <a className="community-map-popup__title" href={thing.url}>{thing.name}</a>
                    <div className="community-map-popup__type">{thing.type_label}</div>
                    <div className="community-map-popup__description">{thing.short_description}</div>
                    <div className="community-map-popup__location">
                        <i className="fas fa-map-marker-alt"></i><span className="sr-only">Location</span>{thing.location_address}
                    </div>
                    {thing.date_representation === null ? null : (
                        <div className="community-map-popup__date">
                            <i className="far fa-calendar-days"></i><span className="sr-only">Date</span>{thing.date_representation}
                        </div>
                    )}
                    <a className="community-map-popup__link" href={thing.url}>
                        View Details
                        <div className="button__icon--inline"><i className="fas fa-chevron-left fa-rotate-180"></i></div>
                    </a>
                </div>
            </Popup>
        </Marker >
    )
}


function CommunityEventMap({ things }) {
    return (
        <MapContainer
            style={{ height: "100%", width: "100%" }}
            attributionControl={false}
            zoom={6}
            center={[52.451521, -1.7228148]}
            minZoom={6}
            maxZoom={18}
        >
            <TileLayer
                attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            />
            {things.map((thing) => (
                <ThingMarker key={thing.id} thing={thing} />
            ))}
        </MapContainer>
    )

}

export default CommunityEventMap